import { useEffect, useMemo, useState } from 'react';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import sleep from "sleep-promise";
import { useDispatch } from 'react-redux';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/resourcesources/';
    const [filterValues, setFilterValues] = useState({});
    const dispatch = useDispatch();
    const paths = useMemo(() => ({
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllResourceSourceClassification: config.endpoints.backend + 'resourcesourcesclassifications/getall',
        endpointDelete: `${config.endpoints.backend}resourcesources/delete`,
        endpoint: config.endpoints.backend + 'resourcesources/getall'
    }), []);

    async function updateSession(){
        await sleep(10);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    }

    useEffect(() => {
        async function update(){
            await updateSession();
        }    

        update();
    }, [filterValues])

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = {...filterValues, [target['name']]: target['value']};
        filters = clearFilters(target,filters);
        setFilterValues(filters)
        
        await updateSession();
    }

    const clearFilters = (target, filterObject) => {
        const filterName = target['name'];
        if(filterName === 'pdc_entity_id'){
            filterObject = {pdc_entity_id: target['value']};
            if(filterValues.value_start && filterValues.value_end){
                filterObject = {...filterObject, pdc_resource_source_classification_id: ''};
            }
        }
        return filterObject;
    }

    const filters = useMemo(() => ({
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        update_key: `${filterValues.pdc_entity_id}`,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'pdc_resource_source_classification_id',
                type: 'select',
                label: 'Classificação',
                options: [],
                handleChange,
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllResourceSourceClassification,
                    label: 'description',   
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter,
                            pdc_entity_id: !!filterValues.pdc_entity_id ? filterValues.pdc_entity_id : profileFilter.pdc_entity_id
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
        ],
        values: {
            pdc_entity_id: filterValues.pdc_entity_id,
            pdc_resource_source_classification_id: filterValues.pdc_resource_source_classification_id
        }
    }), [paths, filterValues]);

    const list = useMemo(() => {
        let list = {
            labelTitle: 'Lista de Origem de recursos',
            labelTitleButtonAdd: 'Incluir nova Origem de recursos',
            fieldsShowOnDelete: ['entity_name','description'],
            formFilters: filters,
            showPrintButtons: true,
            filter: {
                ...profileFilter,
                pdc_entity_id: !!filterValues.pdc_entity_id ? filterValues.pdc_entity_id : profileFilter.pdc_entity_id,
                pdc_resource_source_classification_id: filterValues.pdc_resource_source_classification_id
            },
            columns: [
                {
                    name: 'entity_name',
                    label: 'Entidade'
                },
                {
                    name: 'classification_name',
                    label: 'Classificação'
                },
                {
                    name: 'description',
                    label: 'Classificação'
                }
            ]
        }
    
        list = { ...list, ...paths };

        return list;

    },[paths, filters]);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list, paths, filters]);

    const customListContainer = useMemo(() => (
        <CustomListContainer
            pathAdd={paths.pathAdd}
            labelTitle={list.labelTitle}
            labelTitleButtonAdd={list.labelTitleButtonAdd}
            content={content}
        />
    ), [content, paths, filters, list]);

    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;
